import Campo from './Campo';
import BotaoPrincipal from './BotaoPrincipal';
import { mascaraCpf, mascaraDataBr } from '../utils';

interface PassoIdentificarProps {
  cpf: string;
  nascimento: string;
  erro: string | null;
  buscando: boolean;
  aoMudarCpf: (v: string) => void;
  aoMudarNascimento: (v: string) => void;
  aoContinuar: () => void;
}

// Passo 1 — quem está preenchendo.
export default function PassoIdentificar({
  cpf,
  nascimento,
  erro,
  buscando,
  aoMudarCpf,
  aoMudarNascimento,
  aoContinuar,
}: PassoIdentificarProps) {
  return (
    <div className="rounded-2xl border border-background-200 bg-white p-5">
      <h2 className="text-[17px] font-bold text-foreground-950">Quem é você</h2>
      <p className="mt-1 text-[15px] leading-relaxed text-foreground-700">
        Se você é da equipe e vai levar seus filhos, preencha aqui. Leva uns 5 minutos.
      </p>

      <div className="mt-5 space-y-4">
        <Campo
          id="campo-cpf"
          rotulo="Seu CPF"
          valor={cpf}
          aoMudar={(v) => aoMudarCpf(mascaraCpf(v))}
          placeholder="000.000.000-00"
          inputMode="numeric"
          maxLength={14}
          autoComplete="off"
        />
        <Campo
          id="campo-nascimento"
          rotulo="Sua data de nascimento"
          valor={nascimento}
          aoMudar={(v) => aoMudarNascimento(mascaraDataBr(v))}
          placeholder="dd/mm/aaaa"
          inputMode="numeric"
          maxLength={10}
          autoComplete="off"
        />
      </div>

      <div className="mt-5">
        <BotaoPrincipal aoTocar={aoContinuar} carregando={buscando}>
          {buscando ? 'Abrindo…' : 'Continuar'}
        </BotaoPrincipal>
        {erro && (
          <p className="mt-3 flex items-start gap-1.5 text-[14px] text-danger-600" role="alert">
            <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
              <i className="ri-error-warning-line" aria-hidden />
            </span>
            {erro}
          </p>
        )}
      </div>

      <p className="mt-4 text-[13px] leading-relaxed text-foreground-500">
        Seus dados não ficam salvos neste aparelho. Só usamos para achar a sua ficha da equipe.
      </p>
    </div>
  );
}